import { render, staticRenderFns } from "./MealPlansList.vue?vue&type=template&id=9d82cce8"
import script from "./MealPlansList.vue?vue&type=script&lang=js"
export * from "./MealPlansList.vue?vue&type=script&lang=js"
import style0 from "./MealPlansList.vue?vue&type=style&index=0&id=9d82cce8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports